import Vue from "vue"
import {updateField} from "vuex-map-fields"
import {getField} from "vuex-map-fields"

export const state = () => ({
    navigating: false
})

export const actions = {

}

export const getters = {
    getField,
}

export const mutations = {
    updateField,
    setNavigating(state, value){
        state.navigating = value
    },
}
